import React, {Component} from 'react';
import { connect } from 'react-redux';

import UserList from '../UserList/index';
import UserListSortPopup from '../UserListSortPopup/index';
import Registry from '../../../registry/index';

import PmMenu from '../PmMenuMobile/index';
import {Scrollbars} from "react-custom-scrollbars";

class SidebarRight extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cssClass: props.sidebarRightShown ? 'shown' : 'hidden'
        };

        this.onAnimationEnd = this.onAnimationEnd.bind(this);
    }

    _renderSortingPopup(props) {
        UserListSortPopup.mount({
            users: props.users,
            browser: props.browser,
            currentUser: props.currentUser,
            userSorting: props.userSorting,
            anchor: this._sortingPopupButton,
            dispatch: props.dispatch,
            watcherCount: props.watcherCount,
            ref: (r) => this.sortPopup = r
        });
    }

    onAnimationEnd(event) {
        switch (event.animationName) {
            case 'right_cont_show':
                this.setState({cssClass: 'shown'});
                // this.props.onShownFn();
                break;
            case 'right_cont_hide':
                this.setState({cssClass: 'hidden'});
                // this.props.onHideFn();
                break;
        }
    }

    componentDidMount() {
        this._renderSortingPopup(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this._renderSortingPopup(nextProps);

        if (!this.props.sidebarRightShown && nextProps.sidebarRightShown) {
            this.setState({cssClass: 'showing_up'})
        }
        if (this.props.sidebarRightShown && !nextProps.sidebarRightShown) {
            this.setState({cssClass: 'hiding_up'})
        }
    }

    render() {
        const lang = Registry.get('locale');

        const { users, currentUser, pmOpened, browser: { mobile } } = this.props;

        const cssClasses = ['right-cont'];
        cssClasses.push(this.state.cssClass);

        const room = this.props.rooms[this.props.visibleRoom];

        const amountAvailable = currentUser.wallet_amount ? currentUser.wallet_amount : 0;
        const userList = mobile ? (room && !pmOpened) : (room);
        const pmMenu = mobile ? pmOpened : false;

        return (
            <div className={cssClasses.join(' ')} onAnimationEnd={this.onAnimationEnd}>
                <div className="block-right-cont">
                    <div className={`top-block-right-cont ${!userList ? `hidden` : ``}`}>
                        <div className="points" target="_blank">{amountAvailable} {(amountAvailable > 1 ? lang.tokens : (amountAvailable === 1 ? lang.token : lang.token0))}</div>
                        <div className="info" dangerouslySetInnerHTML={{__html: lang.right_point_info}} />
                        <p className="name"><span id="room-user-count">{users.size}</span></p>
                        <div
                            className="more-vert popup-opener"
                            ref={(sortingPopupButton) => this._sortingPopupButton = sortingPopupButton}
                            onClick={() => this.sortPopup.open()}
                         />
                        <div className="close" />
                    </div>
                    <div id="user-list-container" className={`list-block-right ${pmMenu ? 'no-margin' : ''}`}>
                        <Scrollbars
                            className="scrollbars"
                            renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                            renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}
                        >
                            {userList ? <UserList room={room} roomid={room.roomid} /> : null}
                            {pmMenu && <PmMenu dispatch={this.props.dispatch} />}
                        </Scrollbars>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    let rooms = {};
    for (let roomid in state.rooms) {
        let room = state.rooms[roomid];
        if (room.active) {
            rooms[roomid] = room;
        }
    }

    let users = {};
    let watcherCount = {};

    let room = state.rooms[state.visibleChatrooms.roomid];
    if (room) {
        users = room.users;
        watcherCount = room.watcherCount;
    }

    let pmOpened = false;
    for (let uid in state.pm.conversations) {
        if (state.pm.conversations[uid].view.maximized) {
            pmOpened = true;
            break;
        }
    }

    return {
        // todo: change to currentRoomUserCount prop to prevent frequent DOM updates
        visibleRoom: state.visibleChatrooms.roomid,
        rooms: rooms,
        users: users,
        browser: state.browser,
        currentUser: state.currentUser,
        userSorting: state.userSorting,
        sidebarRightShown: state.sidebars.rightShown,
        watcherCount: watcherCount,
        pmOpened,
    }
}

export default connect(mapStateToProps)(SidebarRight);



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/SidebarRight/index.js